import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getFiatTransactionDetail } from '../fiatTransactionsEndpoints'
import { fiatTransactionKeys } from '../fiatTransactionsQueryKeys'

export function useFiatTransactionDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => fiatTransactionKeys.detail(toValue(id)),
    queryFn: () => getFiatTransactionDetail(toValue(id)),
    enabled: () => !!toValue(id),
  })
}
